import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import * as reportGeneration from '../../../../../redux/reportGeneration';
import type { ReportCategory } from '../../shared/types';
import type { DependencyMetadataFilterOption, FormatName, IncludeFilterOption } from '../shared/types';
import type { Revision } from '../../../../../../shared/model-typings';
import ProjectActionButtons from './ProjectActionButtons';
import ProjectGroupActionButtons from './ProjectGroupActionButtons';

type Props = {
  isDisabled?: boolean;
  reportType: ReportCategory;
  format: FormatName | null;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
  revision?: Revision;
};

const ActionButtons: VoidFunctionComponent<Props> = ({
  format,
  reportType,
  includeOptions,
  dependencyMetadataOptions,
  isDisabled,
  revision,
}: Props) => {
  const projectType = useSelector(reportGeneration.selectors.getProjectType);

  return projectType === 'project' ? (
    <ProjectActionButtons
      format={format}
      reportType={reportType}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      isDisabled={isDisabled}
      revision={revision} />
  ) : (
    <ProjectGroupActionButtons
      format={format}
      reportType={reportType}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      isDisabled={isDisabled} />
  );
};

export default ActionButtons;
